import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import moment from 'moment'
import VueGtag from "vue-gtag";
import axios from 'axios'

import session, { setStore } from '@/api/session';
import { TOKEN_STORAGE_KEY } from '@/config/runtime';

import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

const token = localStorage.getItem(TOKEN_STORAGE_KEY)
if (token) {
  axios.defaults.headers.common['Authorization'] = `Token ${token}`
  session.defaults.headers.Authorization = `Token ${token}`
}

setStore(store);

new Vue({
  vuetify,
  router,
  store,
  beforeCreate() {
    this.$store.dispatch('dataTable/loadStateFromStorage');
  },
  moment,
  render: h => h(App)
}).$mount('#app')

// PROD
Vue.use(VueGtag, {
  config: { id: "G-VRY0N7X7HX" }
}, router);

// TEST
// Vue.use(VueGtag, {
//   config: { id: "G-NETNFCKFQ8" }
// }, router);
